// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"545":"91329eedf2760db5","4148":"d31f136cb92fa886","9921":"9e9ca47cf93a101c"}[chunkId] + ".js";
};